<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Sản phẩm chuỗi</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on:click="showDialog()"
          >
            <v-icon left>mdi-plus</v-icon>
            thêm mới
          </v-btn>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
                <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
                <v-spacer/>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.san_pham="{ item }">
        <div class="product-name">
          {{ item.san_pham }}
        </div>
      </template>
      <template v-slot:item.logo="{ item }">
        <v-img
          v-if="item.logo"
          :src="`${apiBaseUrl}/uploads/${item.logo}`"
          lazy-src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="green"
              />
            </v-row>
          </template>
        </v-img>
        <v-img
          v-else
          src="@/assets/NoImage.jpg"
          class="ma-2"
          width="120"
        >
        </v-img>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-btn
            icon
            color="primary"
            @click="editItem(item)"
          >
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-btn
            icon
            color="pink"
            @click="deleteItem(item)"
          >
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/products/chain/Form';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: {
      Form
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Logo', value: 'logo', sortable: false },
        { text: 'Sản phẩm', value: 'san_pham' },
        { text: 'Cơ sở được cấp giấy xác nhận chuỗi', value: 'co_so' },
        { text: 'Địa chỉ', value: 'dia_chi' },
        { text: 'Điện thoại', value: 'dien_thoai' },
        { text: 'Quy mô/Sản lượng chuỗi', value: 'quy_mo' },
        { text: 'Vùng nguyên liệu', value: 'material_area.name' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      options: {},
      editedIndex: -1,
      item: {}
    }),
    computed: {
      ...mapState([ 
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        let url = "api/v1/product-chains";
        const { page, itemsPerPage } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            keyword: this.search
          }
        };
        app.loading = true;
        axios.get(url, request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{
          images: [],
          cert_images: []
        };
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/product-chains/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      }
    }
  }
</script>
<style scoped>
  .product-name:first-letter {
    text-transform: uppercase;
  }
</style>